import { Route, Routes } from 'react-router-dom'
import Home from 'pages/Home/Home'
import Apllos from 'pages/Apllos/Apllos'
import Contact from 'pages/Contact/Contact'
import Recognition from 'pages/Recognition/Recognition'
import Cases from 'pages/Cases/Cases'
import Delfos from 'pages/DataCases/Delfos/Delfos'
import EstruturadeDadosHorizontal from 'pages/DataCases/EstruturadeDadosHorizontal/EstruturadeDadosHorizontal'
import FretesAnalytics from 'pages/DataCases/FreteAnalytics/FreteAnalytics'
import FreteInsights from 'pages/DataCases/FretesInsights/FretesInsights'
import FretesMachineLearning from 'pages/DataCases/FretesMachineLearning/FretesMachineLearning'
import IntegraSAPIBP from 'pages/DataCases/IntegraSAPIBP/IntegraSAPIBP'
import KanbanLogisticoInteligente from 'pages/DataCases/KanbanLogisticoInteligente/KanbanLogisticoInteligente'
import MigracaoDeDadosDatabricks from 'pages/DataCases/MigracaoDeDadosDatabricks/MigracaoDeDadosDatabricks'
import QualidadeEGovernanca from 'pages/DataCases/QualidadeEGovernanca/QualidadeEGovernanca'
import Complex from 'pages/CXCases/Complex/Complex'
import RedesenhoDoFluxo from 'pages/CXCases/RedesenhoDoFluxo/RedesenhoDoFluxo'
import RoadMaps from 'pages/CXCases/RoadMaps/RoadMaps'
import ServiceDesignSAC from 'pages/CXCases/ServiceDesignSAC/ServiceDesignSAC'
import PlataformaDeECommerce from 'pages/DigitalCases/PlataformaDeECommerce/PlataformaDeECommerce'
import PlataformaDeExportacao from 'pages/DigitalCases/PlataformaDeExportacao/PlataformaDeExportacao'
import PlataformaDeGestaoDePrecos from 'pages/DigitalCases/PlataformaDeGestaoDePrecos/PlataformaDeGestaoDePrecos'
import AbastecimentoEPoliticaDeEstoque from 'pages/DigitalSupplyChainCases/AbastecimentoEPoliticaDeEstoque/AbastecimentoEPoliticaDeEstoque'
import ConfirmacaoDeDisponibilidade from 'pages/DigitalSupplyChainCases/ConfirmacaoDeDisponibilidade/ConfirmacaoDeDisponibilidade'
import MalhaLogisticaNoSistema from 'pages/DigitalSupplyChainCases/MalhaLogisticaNoSistemaAPS/MalhaLogisticaNoSistemaAPS'
import PlanejamentoEOtimizacao from 'pages/DigitalSupplyChainCases/PlanejamentoEOtimizacao/PlanejamentoEOtimizacao'
import PlanejamentoNaIndustria from 'pages/DigitalSupplyChainCases/PlanejamentoNaIndustria/PlanejamentoNaIndustria'
import PrevisaoDeDemanda from 'pages/DigitalSupplyChainCases/PrevisaoDeDemanda/PrevisaoDeDemanda'
import ProjetoDreams from 'pages/DigitalSupplyChainCases/ProjetoDreams/ProjetoDreams'
import IntegraSAPIBPSupply from 'pages/DigitalSupplyChainCases/IntegraSAPIBPSupply/IntegraSAPIBPSupply'
import HubDeIa from 'pages/IACases/HubDeIa/HubDeIa'
import IAAssistenteDeManutencao from 'pages/IACases/IAAssistenteDeManutencao/IAAssistenteDeManutencao'
import IAAssistenteRH from 'pages/IACases/IAAssistenteRH/IAAssistenteRH'
import LeitorDePedido from 'pages/IACases/LeitorDePedidos/LeitorDePedidos'
import CustomerInsights from 'pages/IACases/CustomerInsights/CustomerInsights'
import Digital from 'pages/SolutionsPage/Digital/Digital'
import Data from 'pages/SolutionsPage/Data/Data'
import DigitalSupplyChain from 'pages/SolutionsPage/DigitalSupplyChain/DigitalSupplyChain'
import CustomerExperience from 'pages/SolutionsPage/CustomerExperience/CustomerExperience'
import AiAgent from 'pages/SolutionsPage/AiAgent/AiAgent'
import ScrollToTop from './scrolltop'

const AppRoutes = () => {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/digital-transformation" element={<Digital />} />
        <Route path="data" element={<Data />} />
        <Route path="digital-supply-chain" element={<DigitalSupplyChain />} />
        <Route path="cx-ax" element={<CustomerExperience />} />
        <Route path="agente-de-ia" element={<AiAgent />} />
        <Route path="/apllos" element={<Apllos />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/recognition" element={<Recognition />} />
        <Route path="/cases" element={<Cases />} />
        <Route path="/delfos" element={<Delfos />} />
        <Route path="/kanban" element={<KanbanLogisticoInteligente />} />
        <Route
          path="/migracao-de-dados-databricks"
          element={<MigracaoDeDadosDatabricks />}
        />
        <Route
          path="/estrutura-de-dados-horizontal"
          element={<EstruturadeDadosHorizontal />}
        />
        <Route path="/fretes-analytics" element={<FretesAnalytics />} />
        <Route path="/fretes-insights" element={<FreteInsights />} />
        <Route path="/fretes-machine-learning" element={<FretesMachineLearning />} />
        <Route path="/integra-SAP-IBP" element={<IntegraSAPIBP />} />
        <Route path="/qualidade-e-governanca" element={<QualidadeEGovernanca />} />
        <Route path="/complex" element={<Complex />} />
        <Route path="/redesenho-do-fluxo" element={<RedesenhoDoFluxo />} />
        <Route path="/road-maps" element={<RoadMaps />} />
        <Route path="/service-design-SAC" element={<ServiceDesignSAC />} />
        <Route path="/plataforma-de-e-commerce" element={<PlataformaDeECommerce />} />
        <Route path="/plataforma-de-exportacao" element={<PlataformaDeExportacao />} />
        <Route
          path="/plataforma-de-gestao-de-precos"
          element={<PlataformaDeGestaoDePrecos />}
        />
        <Route
          path="/abastecimento-e-politica-de-estoque"
          element={<AbastecimentoEPoliticaDeEstoque />}
        />
        <Route
          path="/confirmacao-de-disponibilidade"
          element={<ConfirmacaoDeDisponibilidade />}
        />
        <Route path="/integra-SAP-IBP-supply-chain" element={<IntegraSAPIBPSupply />} />
        <Route path="/malha-logistica-no-sistema" element={<MalhaLogisticaNoSistema />} />
        <Route path="/planejamento-e-otimizacao" element={<PlanejamentoEOtimizacao />} />
        <Route path="/planejamento-na-industria" element={<PlanejamentoNaIndustria />} />
        <Route path="/previsao-de-demanda" element={<PrevisaoDeDemanda />} />
        <Route path="/projeto-dreams" element={<ProjetoDreams />} />
        <Route path="/hub-de-ia" element={<HubDeIa />} />
        <Route
          path="ia-assistente-de-manutencao"
          element={<IAAssistenteDeManutencao />}
        />
        <Route path="ia-assistente-rh" element={<IAAssistenteRH />} />
        <Route path="leitor-de-pedidos" element={<LeitorDePedido />} />
        <Route path="customer-insights" element={<CustomerInsights />} />
      </Routes>
    </>
  )
}

export default AppRoutes
